const bme22 = {
  red: '#C20102',
  'red-dark': '#600312',
}

export default bme22
